var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ShadowBox } from '@hn-ui/boxes';
import { Tooltip } from '@hn-ui/tooltips';
import { Help } from '@hn-ui/icons';
import { styled } from 'styled-components';
import { Charts } from './Charts';
import { useSkillsSummary } from './hooks/useSkillsSummary';
import { SkillsReportEvents, useSkillsReportAnalytics, } from '../../hooks/useSkillsReportAnalytics';
var ScWrapper = styled(ShadowBox).withConfig({ displayName: "ScWrapper", componentId: "sc-1x1u82u" })(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var ScTitle = styled.h3.withConfig({ displayName: "ScTitle", componentId: "sc-rjd9ia" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-top: 0;\n  margin-bottom: 32px;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  color: ", ";\n  display: flex;\n  align-items: center;\n  gap: 0 4px;\n"], ["\n  margin-top: 0;\n  margin-bottom: 32px;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  color: ", ";\n  display: flex;\n  align-items: center;\n  gap: 0 4px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.black60;
});
var SkillsSummary = function (_a) {
    var groupId = _a.groupId, domains = _a.domains, minPlacementGradeValue = _a.minPlacementGradeValue, onChartClick = _a.onChartClick, props = __rest(_a, ["groupId", "domains", "minPlacementGradeValue", "onChartClick"]);
    var _b = useSkillsSummary({
        groupId: groupId,
        domains: domains,
        minPlacementGradeValue: minPlacementGradeValue,
    }), skillsSummary = _b.skillsSummary, onlyPKStudents = _b.onlyPKStudents;
    var sendGaEvent = useSkillsReportAnalytics();
    if (!skillsSummary)
        return null;
    return (_jsxs(ScWrapper, __assign({}, props, { children: [_jsxs(ScTitle, { children: [_jsx("span", { children: "Student skill level by grade and domain" }, void 0), _jsx(Tooltip, __assign({ maxWidth: 311, content: "The graphs show students' skill progress in each domain according to the grade level they're working at. The lowest grades are hidden if there are no developing or help needed skills there." }, { children: _jsx(Help, { size: 24, disabled: true, onMouseEnter: function () {
                                sendGaEvent(SkillsReportEvents.diagramsHelpHover);
                            } }, void 0) }), void 0)] }, void 0), _jsx(Charts, { data: skillsSummary, onClick: onChartClick, hasOnlyPKStudents: onlyPKStudents }, void 0)] }), void 0));
};
export { SkillsSummary };
var templateObject_1, templateObject_2;
